import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { jsonHeader, serverUrl } from '../../config';
import { history } from '../../helpers';

export default function Oauth2Authorization() {
  const user = useSelector(state => state.authentication.user);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!user) {
    history.push(`/login?continue=${encodeURIComponent(window.location.href)}`)
  }

  const conrimAndProcess = () => {
    setSubmitting(true);
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user.jwtToken}` };
    const requestOptions = {
      method: 'GET',
      headers: headerWithAuth,
    };

    const authUrl = `${serverUrl}/oauth2/authorize${window.location.search}`;
    fetch(authUrl, requestOptions)
      .then((results) => {
        if (!results.ok) {
          throw Error(results.statusText);
        }
        return results.json();
      }).then((data) => {
        if (data?.error !== '') {
          setError(data?.message);
        } else {
          window.location.href = data.location;
        }
        setSubmitting(false);
      }).catch(() => {
        setError('We are having problems Authorizing this App, please try again later.');
        setSubmitting(false);
      });
  };


  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">OAuth2 Authorization Flow</h3>
        </Col>
      </Row>
      <Row>
        <br />
      </Row>
      {error === '' && (
        <Row>
          <Col md={6}>
            <div className="account__wrapper">
              <h4>Service Consent</h4>
              <br />
              <p>
                By using this service, you acknowledge that ChatGPT can make mistakes.
                <br />
                <br />
                <button type="button" className="btn btn-primary" disabled={submitting} onClick={() => conrimAndProcess()}>Authorize Connection</button>
              </p>
              {error}
              <br />
            </div>
          </Col>
        </Row>
      )}
      {error !== '' && (
        <Row>
          <Col md={6}>
            <div className="account__wrapper">
              <h4>Authorization Error</h4>
              <br />
              <p>
                {error}
              </p>
              <br />
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <br />
      </Row>
    </Container>
  );
}
